import { Grid, pn, Switch, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { StudentApplicationFilter as StudentApplicationFilterModel, StudentFileCategorizedFilter, StudentFileCategorizedListFilter, StudentFileFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentFileFilter = (props: {
  filter: StudentFileCategorizedFilter;
  setFilter: (value: StudentFileCategorizedFilter) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentFileFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.studentFiles.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const fileCategoryField = () => {
    const propertyName = pn<StudentFileCategorizedFilter>("fileCategoryIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        label="File Categories"
        value={resource.fileCategories?.filter((x) => props.filter.fileCategoryIds?.includes(x.id))}
        options={resource.fileCategories}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.fileCategoryIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const includeApplicationField = () => {
    const propertyName = pn<StudentFileCategorizedFilter>("includeApplication");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Switch
        label="Show Application Files"
        onClick={() => {
          props.setFilter(
            produce(props.filter, (draft) => {
              draft!.includeApplication = !props.filter.includeApplication;
            })
          );
        }}
        checked={props.filter.includeApplication}
      ></Switch>
    );
  };

  const includeStudentFileField = () => {
    const propertyName = pn<StudentFileCategorizedFilter>("includeStudentFile");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Switch
        label="Show Student Files"
        onClick={() => {
          props.setFilter(
            produce(props.filter, (draft) => {
              draft!.includeStudentFile = !props.filter.includeStudentFile;
            })
          );
        }}
        checked={props.filter.includeStudentFile}
      ></Switch>
    );
  };

  const includeStudentServiceField = () => {
    const propertyName = pn<StudentFileCategorizedFilter>("includeStudentServiceFile");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Switch
        label="Show Student Service Files"
        onClick={() => {
          props.setFilter(
            produce(props.filter, (draft) => {
              draft!.includeStudentServiceFile = !props.filter.includeStudentServiceFile;
            })
          );
        }}
        checked={props.filter.includeStudentServiceFile}
      ></Switch>
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {fileCategoryField()}
      </Grid>
      <Grid item xs={largeFieldBreakpoints}>
        {includeStudentFileField()}
      </Grid>
      <Grid item xs={largeFieldBreakpoints}>
        {includeApplicationField()}
      </Grid>
      <Grid item xs={largeFieldBreakpoints}>
        {includeStudentServiceField()}
      </Grid>
    </Grid>
  );
};
